export const UpgradeCostUnit = {
    /**
     * @constant
     * @type {string}
     */
    FREE: 'free',
    /**
     * @constant
     * @type {string}
     */
    ORE: 'Ore',
    /**
     * @constant
     * @type {string}
     */
    GOLD: 'Gold', 
    /**
     * @constant
     * @type {string}
     */
    PRESTIGE: 'Prestige'
}